import filter from 'lodash/filter'

const getters = {
  currentUserId: state => {
    return state.current_user.getId() ? state.current_user.getId() : null
  },
  currentUserRole: state => {
    return state.current_user.getRole() ? state.current_user.getRole() : 'none'
  },
  currentUser: state => {
    return state.current_user.get() ? state.current_user.get() : null
  },
  currentUserObj: state => {
    return state.current_user ? state.current_user : null
  },
  currentPermissions: state => {
    return state.permissions ? state.permissions : {}
  },
  isLoggedIn: state => {
    return Boolean(state.current_user.getId())
  },
  notifications: state => {
    return state.notifications ? state.notifications : []
  },
  unreadNotificationCount: state => {
    return filter(state.notifications, {readTime: null}).length
  },
  handledCasesAreVisible: state => {
    return Boolean(state.handledCasesAreVisible)
  }
}

export default getters
